import { useEffect, useState } from "react"

// Context
import { UserContext } from "../../../../context/userContext"

//Styles
import style from "../../../../styles/referrals/ReferralEntityListHybridView.module.css"

//Helpers
import { LoaderMedium } from "../../../../components/Loaders"
import { displayLocalDateTimeFromIso } from "../../../../helpers/displayDates"

//PrimeReact
import { Paginator } from "primereact/paginator"
import { Button } from "primereact/button"
import MapSearchMap from "../EntitySearch/MapSearchMap"
import { useContext } from "react"
import { SplitButton } from "primereact/splitbutton"
import { Badge } from "primereact/badge"
import { GetMapZoomRange } from "../sharedFunctions"

export default function ReferralEntitiesListHybridView({
  isLoadingList,
  showListMap,
  partnerData,
  partnerLocationData,
  isPartnerUser,
  onEditPartner,
  onShowPartnerServices,
  onPageChange,
  //Map variables
  isLoadingMap,
  mapHeight,
  mapFitToBounds,
  mapCachedMap,
  mapDefaultCenteredLocation,
  mapDefaultFocusedLocation,
  mapMarkerPoints,
  mapOnSetCachedMap,
  mapOnSetDefaultFocusedLocation,
  mapOnSetZoomRange,
}) {
  const userCtx = useContext(UserContext)

  const [centerLocation, setCenterLocation] = useState({
    longitude: -77,
    latitude: 38,
  })

  const [mapshowPopupEntity, setMapShowPopupEntity] = useState()

  useEffect(() => {
    setCenterLocation(mapDefaultCenteredLocation)
  }, [mapDefaultCenteredLocation])

  /*   //When the place changes, change the center of the map
  function onPlaceChanged(place) {
    const placeDetail = RefGetAddressFromPlace(place)

    if (placeDetail.longitude && placeDetail.latitude) {
      mapOnSetDefaultFocusedLocation({
        longitude: placeDetail.longitude,
        latitude: placeDetail.latitude,
      })
    }

    return ""
  } */

  const locatePartner = (location) => {
    setCenterLocation({
      longitude: location.longitude,
      latitude: location.latitude,
    })
    setMapShowPopupEntity(location)
  }

  const getPartnerPanel = (partnerData) => {
    const date = displayLocalDateTimeFromIso(
      partnerData.referralEntity.dateCreated
    )

    let canEdit =
      isPartnerUser ||
      userCtx.session.user.staff_role === 1 ||
      (userCtx.session.user.staff_role > 1 &&
        userCtx.session.user.staff_role <= 6 &&
        userCtx.session?.organizations?.some(
          (x) =>
            x.organization_id ===
            (partnerData.referralEntity?.creationOrganizationId ||
              "No creator org")
        ))

    const locations = partnerLocationData?.filter(
      (location) => location.entityId === partnerData.referralEntity.id
    )

    let locationOptions = []
    let primaryLocation = undefined
    if (!!locations) {
      locationOptions = locations
        .filter((location) => !!location.longitude && !!location.latitude)
        .map((location) => {
          return {
            label: `${location.name}: ${location.address}`,
            command: () => {
              locatePartner(location)
            },
          }
        })

      primaryLocation = locations.find(
        (location) =>
          location.locationId === partnerData.referralEntity.primaryLocationId
      )
    }

    let refEntityStatus = "warning"

    if (partnerData.referralEntity.entityStatus === "confirmed") {
      refEntityStatus = "success"
    } else if (partnerData.referralEntity.entityStatus === "under review") {
      refEntityStatus = "info"
    }

    return (
      <div className={style.partnerGrid}>
        <div className={style.partnerGridItemNameTitle}>Name:</div>
        <div className={style.partnerGridItemName}>
          {partnerData.referralEntity.name}
        </div>
        <div className={style.partnerGridItemStatusTitle}>Status:</div>
        <div className={style.partnerGridItemStatus}>
          <span
            className="badgeSpan"
            data-pr-tooltip="This status indicates whether a partner has confirmed their account information as correct"
          >
            <Badge
              value={
                partnerData.referralEntity.entityStatus
                  ? partnerData.referralEntity.entityStatus
                  : "unconfirmed"
              }
              severity={refEntityStatus}
              tooltip="ToolTip"
            />
          </span>
        </div>
        <div className={style.partnerGridItemCityTitle}>City:</div>
        <div className={style.partnerGridItemCity}>{partnerData.city}</div>
        <div className={style.partnerGridItemCreatorTitle}>Creator:</div>
        <div className={style.partnerGridItemCreator}>
          {`${partnerData.creatingUserName || "Unknown"}`}
        </div>
        <div className={style.partnerGridItemCreatorOrgTitle}>
          Creator organization:
        </div>
        <div className={style.partnerGridItemCreatorOrg}>
          {partnerData.creatingOrganization || "Unknown"}
        </div>
        <div className={style.partnerGridItemCreationTitle}>Created on:</div>
        <div className={style.partnerGridItemCreation}>{date}</div>
        <div className={style.partnerGridItemAction}>
          <Button
            type="button"
            className={`${style.actionButton}`}
            onClick={() => {
              onEditPartner(partnerData.referralEntity.id)
            }}
            disabled={isLoadingList}
          >
            {canEdit ? "Edit" : "View"}
          </Button>
          <Button
            type="button"
            className={`bn ${style.actionButton}`}
            onClick={() => {
              onShowPartnerServices(
                partnerData.referralEntity.name,
                partnerData.referralTypes
              )
            }}
            disabled={isLoadingList}
          >
            {`Services: [${
              !!partnerData.referralTypes ? partnerData.referralTypes.length : 0
            }]`}
          </Button>
          {locationOptions.length > 0 ? (
            <SplitButton
              label="Locate"
              className={`${style.actionButton}`}
              model={locationOptions}
              onClick={() => {
                if (!!primaryLocation) {
                  locatePartner(primaryLocation)
                }
              }}
            />
          ) : null}
        </div>
      </div>
    )
  }

  const onMouseWheelZoom = (event) => {
    const zoom = event.target.getZoom()

    const zoomRange = GetMapZoomRange(zoom)

    mapOnSetZoomRange(zoomRange)
  }

  return (
    <div className={showListMap ? style.grid : style.mapGrid}>
      {showListMap ? (
        <>
          <div className={style.gridItemList}>
            <div className={style.partnerContainer}>
              {!!partnerData && !isLoadingList ? (
                partnerData?.result.map((partner, index) => (
                  <div key={index}>{getPartnerPanel(partner)}</div>
                ))
              ) : isLoadingList ? (
                <LoaderMedium />
              ) : null}
            </div>
          </div>
          <div className={style.gridItemPage}>
            <Paginator
              first={partnerData?.pageSize * (partnerData?.pageNum - 1)}
              rows={partnerData?.pageSize}
              totalRecords={partnerData?.numTotal}
              onPageChange={onPageChange}
              disabled={isLoadingList}
            />
          </div>
        </>
      ) : null}

      <div className={style.gridItemMap}>
        {isLoadingMap ? (
          <div className={style.mapLoader}>
            <LoaderMedium />
          </div>
        ) : null}
        <MapSearchMap
          centerLocation={centerLocation}
          focusLocation={mapDefaultFocusedLocation}
          defaultZoom={10}
          onLocationSelect={(locationId) => {
            const location = partnerLocationData?.find(
              (location) => location.locationId === locationId
            )
            if (!!location) {
              onEditPartner(location.entityId)
            } else {
            }
          }}
          fitToBounds={mapFitToBounds}
          thisMap={mapCachedMap}
          onMove={(viewState) => {
            setCenterLocation({
              longitude: viewState.viewState.longitude,
              latitude: viewState.viewState.latitude,
            })
            return ""
          }}
          onWheelZoom={onMouseWheelZoom}
          setThisMap={(map) => {
            mapOnSetCachedMap(map)
          }}
          markerPoints={mapMarkerPoints}
          triggerResize={{ points: mapMarkerPoints, viewState: showListMap }}
          refEntityShowPopup={mapshowPopupEntity}
          triggerRefocus={mapMarkerPoints}
          overrideHeightInPixels={mapHeight || 648}
        />
      </div>
    </div>
  )
}
